import { message, } from "antd";
import { checkDocumentUrl } from "./common";

const pcRouter = [
  "/videoPlayer",
  "/freedownload",
  "/questionsDetail",
  "/questions",
  "/login",
  "/register_account",
  "/user/info",
  "/user/info",
  "/videoCollection",
  "/video/pc",
  "/video/fly",
];
const mobileRouter = [
  "/pages/videoPlayer/videoPlayer",
  "/pages/freedownload/freedownload",
  "/pages/questions/questionDetail?id=",
  "/pages/questions/questions",
  "/pages/login/login",
  "/pages/login/register",
  "/pages/user/userInfo/userInfo",
  "/pages/user/userDetail/userDetail",
  "/pages/videoPlayer/videoCollection",
  "/video/pc",
  "/video/fly",
];

const routers=[
  {//视频中心
    mobileRouter:"/pages/videoPlayer/videoPlayer",
    pcRouter:"/videoPlayer"
  },{//资源下载
    mobileRouter:"/pages/freedownload/freedownload",
    pcRouter:"/freedownload"
  },{// 新的问答详情
    mobileRouter:"/pages/questions/questionDetail?id=",
    pcRouter:"/technicalSupport/questionsDetail"
  },{//新的问答列表
    mobileRouter:"/pages/questions/questions",
    pcRouter:"/technicalSupport/questions"
  },{//匹配旧路径问答详情
    mobileRouter:"/pages/questions/questionDetail?id=",
    pcRouter:"/questionsDetail"
  },{//匹配旧路径问答列表
    mobileRouter:"/pages/questions/questions",
    pcRouter:"/questions"
  },{//问答列表
    mobileRouter:"/pages/login/login",
    pcRouter:"/login"
  },{//注册
    mobileRouter:"/pages/login/register",
    pcRouter:"/register_account"
  },{//用户中心
    mobileRouter:"/pages/user/userInfo/userInfo",
    pcRouter:"/user/info"
  },{//个人详情
    mobileRouter:"/pages/user/userDetail/userDetail",
    pcRouter:"/user/info"
  },{//视频播放详情
    mobileRouter:"/pages/videoPlayer/videoCollection",
    pcRouter:"/videoCollection"
  },{//消息中心
    mobileRouter:"/pages/user/messageCenter/index",
    pcRouter:"/message/list"
  },{//消息详情
    mobileRouter:"/pages/user/messageCenter/messageContentDetail",
    pcRouter:"/message/detail"
  },{//费用中心
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/expense/overview"
  },{//支付记录
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/expense/payment"
  },{//充值
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/expense/recharge"
  },{//发票管理
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/expense/invoice"
  },{//在线充值
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/onlineRecharge"
  },{//订单支付
    mobileRouter:"/pages/user/costCenter/index",
    pcRouter:"/orderPay"
  },{//pc视频
    mobileRouter:"/video/pc",
    pcRouter:"/video/pc"
  },{//无人机视频
    mobileRouter:"/video/fly",
    pcRouter:"/video/fly"
  },{// KaihongOS 桌面版（x86）获取页：须写在 /x86 之前，避免 includes 误匹配
    mobileRouter:"/pages/x86/obtain",
    pcRouter:"/x86/obtain"
  },{// KaihongOS 桌面版（x86）详情：PC /x86 → H5 与其它页一致，直连 uni 路由（避免先到 /x86 再由 index.html 二次跳转）
    mobileRouter:"/pages/x86/x86",
    pcRouter:"/x86"
  },{ // x86-beta 活动详情
    mobileRouter:"/pages/activity/x86-beta",
    pcRouter:"/activity/x86-beta"
  },{ // x86-beta 报名页。备注: 借助路由最短匹配规则，即便 PC端分享 `/activity/x86-beta/signup`（填写页），会优先匹配到 /activity/x86-beta， 跳转至移动端报名详情页
    mobileRouter:"/pages/activity/signup",
    pcRouter:"/activity/x86-beta/signup"
  },{//我的fae项目
    mobileRouter:"/pages/technicalSupport/fae/project",
    pcRouter:"/technicalSupport/fae/project"
  },{//fae工单详情
    mobileRouter:"/pages/technicalSupport/fae/detail",
    pcRouter:"/technicalSupport/fae/order/detail"
  },{//我的fae工单
    mobileRouter:"/pages/technicalSupport/fae/order",
    pcRouter:"/technicalSupport/fae/order"
  },{//我的ai助手
    mobileRouter:"/pages/technicalSupport/ai",
    pcRouter:"/technicalSupport/ai"
  },{//fae工单 提单
    mobileRouter:"/pages/technicalSupport/fae/order",
    pcRouter:"/technicalSupport/fae/order/submit"
  },{//文档中心
	mobileRouter:"/document/docs/kaihongos-guides",
	pcRouter:"/document/kaihong-developer-documents/kaihongos-guides"  
  }
]

export const reflectRouter = () => {
  const url = window.location.pathname;
  const urlLower = url.toLowerCase();
  let path = "/";
  const routerIndex = routers.findIndex((item) =>
    urlLower.includes(item.pcRouter.toLowerCase()),
  );
  console.log(url, routerIndex);
  if (routerIndex == -1) {
    //未匹配
    if (urlLower === "/x86") {
      path = "/pages/x86/x86" + window.location.search + window.location.hash;
    } else {
      path = window.location.search + window.location.hash;
    }
  } else {
    if (url.includes("questionsDetail")) {
      // pc 动态路由转 移动路由
      const regex = /.*?\/questionsDetail\//;
      path = url.replace(regex, routers[routerIndex].mobileRouter);
    } else if (url.includes("videoCollection")) {
      path =
        url.replace(routers[routerIndex].pcRouter, routers[routerIndex].mobileRouter) +
        window.location.search;
    } else if(checkDocumentUrl(url)){
			//文档特殊处理
			path=window.location.pathname+window.location.search+window.location.hash;
    } else if (url.includes("/freedownload")) {
      path =
        routers[routerIndex].mobileRouter +
        window.location.search +
        window.location.hash;
    } else if (urlLower.includes("/x86/obtain")) {
      path =
        routers[routerIndex].mobileRouter +
        window.location.search +
        window.location.hash;
    } else {
      path = routers[routerIndex].mobileRouter + window.location.search;
    }
  }
  return path;
};

export default {};
